/**
 * @generated SignedSource<<c898d81d7e71bd949a5cc0c771c47a38>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ViewInRoomImageCredits_viewInRoomPhoto$data = {
  readonly credits: string | null;
  readonly " $fragmentType": "ViewInRoomImageCredits_viewInRoomPhoto";
};
export type ViewInRoomImageCredits_viewInRoomPhoto$key = {
  readonly " $data"?: ViewInRoomImageCredits_viewInRoomPhoto$data;
  readonly " $fragmentSpreads": FragmentRefs<"ViewInRoomImageCredits_viewInRoomPhoto">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ViewInRoomImageCredits_viewInRoomPhoto",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "credits",
      "storageKey": null
    }
  ],
  "type": "viewInRoomPhotos",
  "abstractKey": null
};

(node as any).hash = "2319cf38f1b2a3412836e9ab3adde6c1";

export default node;
